import ChildQuantityGroup from './ChildQuantityGroup';

export default ChildQuantityGroup;
